<template>
<div class="download-parametric">
  <div id="download-protocol-pseudoform">
    <div v-for="param in protocolFields" v-if="param.isFile">
      <!-- Visible file inputs, not in form  -->
      <label>{{param.label}}</label>
      <input
        :name="param.name"
        type="file"
        value=""
        @change="updateFile($event, param.name)"
      >
      </input>
    </div>
    <form
      id="download-protocol-form"
      v-on:submit.prevent="onDownload"
    >
      <div v-for="param in protocolFields" v-if="!param.isFile">
        <label>
          {{param.label}}
        </label>
        <input v-if="param.htmlElem === 'input' && !param.isFile"
          :name="param.name"
          :type="param.type"
          :value="String(fieldValues[param.name])"
          @input="fieldValues[param.name] = param.castToNumber ? Number($event.currentTarget.value) : $event.currentTarget.value"
          :step="param.step"
        >
        </input>
        <select v-if="param.htmlElem === 'select'" :name="param.name" v-model="fieldValues[param.name]">
          <option v-for="opt in param.options" :value="opt.value" :selected="opt.value === opt.default">{{opt.label}}</option>
        </select>
      </div>
      <input
        type="submit"
        :value="'Download For ' + robotTab"
        id="download-protocol"
        :data-gtm-action="subdomain"
        data-gtm-category="Protocol-Download"
        :data-gtm-label="protocolSlug"
      />
    </form>
  </div>
</div>
</template>

<script>
  import FileSaver from 'file-saver'
  import JSZip from 'jszip'

  export default {
    name: 'ParameterizeAndDownload',
    props: ['downloadUrl', 'protocolData', 'protocolSlug', 'robotTab'],
    data: function () {
      return {
        fieldValues: {}
      }
    },
    beforeMount: function () {
      const fields = this.protocolData.fields
      if (fields) {
        // set fieldValues to default values
        let nextValues = fields.reduce((acc, param) => {
          return ({...acc, [param.name]: param.options ? param.options[0].value : param.default})
        }, {})
        this.fieldValues = nextValues
      }
    },
    methods: {
      updateFile (e, fieldName) {
        let reader = new window.FileReader()

        reader.onload = f => {
          const fileContents = f.target.result
          this.fieldValues[fieldName] = fileContents
        }
        reader.readAsText(e.target.files[0])
      },
      onDownload (e) {
        let getValuesFn = (
`def get_values(*names):
    import json
    _all_values = json.loads("""` +
    JSON.stringify(this.fieldValues).replace(/\\n/g, '\\\\n').replace(/\\"/g, '\\\\"').replace(/\\r/g, '') +
    `""")
    return [_all_values[n] for n in names]`)

        const protocolContent = this.protocolData.content
        const customLabwareDefs = this.protocolData.customLabwareDefs

        const finalPyFile = `${getValuesFn}\n\n\n${protocolContent}`
        const pyFileName = `${this.protocolSlug}.py`

        if (customLabwareDefs.length > 0) {
          const zip = new JSZip()
          zip.file(pyFileName, finalPyFile)

          // identify this as "early/beta bundle" for future-compatibilty.
          // Date (2019-09-18) shouldn't change unless bundle is reshaped
          zip.file('.bundle_beta', '2019-09-18')

          // put in custom_labware/ directory for future-proofing.
          // 1. distinguish from standard labware (which may potentially by expected in future bundles)
          // 2. safely avoid filename conflicts with potential non-labware JSON files
          const labwareFolder = zip.folder('custom_labware')
          customLabwareDefs.forEach(def => {
            labwareFolder.file(
              `${def.metadata.displayName}.json`,
              JSON.stringify(def))
          })
          zip.generateAsync({type: 'blob'}).then(content =>
            FileSaver.saveAs(content, `${this.protocolSlug}.zip`))
        } else {
          var blob = new Blob([finalPyFile], {type: 'text/plain;charset=utf-8'}) // eslint-disable-line no-undef
          FileSaver.saveAs(blob, pyFileName)
        }
      }
    },
    computed: {
      subdomain () {
        const subdomain = window.location.href.split('://')[1].split('.')[0]
        // http://protocols.opentrons.com URLs -> subdomain is 'master'
        return subdomain === 'protocols' ? 'master' : subdomain
      },
      protocolFields () {
        const fields = this.protocolData.fields
        if (!fields) {
          return
        }

        return fields.map(param => {
          if (param.type === 'dropDown') {
            return {
              htmlElem: 'select',
              default: param.options[0].value,
              label: param.label,
              name: param.name,
              options: param.options
            }
          }

          const stepVals = {int: '1', float: 'any'}

          // map param.type to <input> type:
          const inputTypes = {
            int: 'number',
            float: 'number',
            str: 'text',
            textFile: 'file'
          }

          return {
            htmlElem: 'input',
            castToNumber: ['int', 'float'].includes(param.type),
            default: param.default,
            isFile: param.type === 'textFile',
            label: param.label,
            name: param.name,
            step: stepVals[param.type],
            type: inputTypes[param.type]
          }
        })
      }
    }
  }
</script>



// WEBPACK FOOTER //
// ParameterizeAndDownload.vue?422c83c1